export interface IPlaceRetreadOrder {
  id: string,
  customerId: string,
  locationId: string,
  typeCode: string,
  billToSundry: string,
}

export interface IPlaceRetreadOrderItem {
  invoiceId: string,
  warehouse: string,
  beginBrandPrefix: string,
  beginBrandNumber: string,
  endBrandNumber: string,
  beginBrandSuffix: string,
  quantity: string,
}

export const emptyPlaceRetreadOrder: IPlaceRetreadOrder = {
  id: '',
  customerId: '',
  locationId: '',
  typeCode: '',
  billToSundry: '',
};

export const emptyPlaceRetreadOrderItem: IPlaceRetreadOrderItem = {
  invoiceId: '',
  warehouse: '',
  beginBrandPrefix: '',
  beginBrandNumber: '',
  endBrandNumber: '',
  beginBrandSuffix: '',
  quantity: '',
};